import React from 'react';
import './ProductPackShapesPicker.css';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { Button, Label } from '@nooz-optics/nooz-components-lib';
import { useMediaQuery } from '../../../../../../utils/hooks/useMediaQuery';
import {
  productPackStepOptionState,
  productState,
  variantState,
} from '../../../../../../utils/recoil/product';
import { Image } from '../../../../../UI/Media';
import { Slider } from '../../../../../UI/Navigation/Slider/slider';

export const ShapePicker = ({
  shapeProduct,
  idx,
  button,
  productsLength,
  shapeIndex,
  category,
}) => {
  const [product, setProduct] = useRecoilState(productState);
  const [productPackStepOption, setProductPackStepOption] = useRecoilState(
    productPackStepOptionState
  );
  const variant = useRecoilValue(variantState);
  const setVariant = useSetRecoilState(variantState);

  const isWindowSmallSize = useMediaQuery('sm');
  const isUniqueProduct = productsLength === 1;
  // Display index 0 or 1 has first image in the slider
  const checkParity = shapeIndex % 2;
  const isButtonDisplayed = button && category;

  const handleOnClick = () => {
    if (!isUniqueProduct) {
      setProduct(shapeProduct);
      setVariant(shapeProduct.variants[0]);

      //
      const productPackOptionStep = [...productPackStepOption];
      productPackOptionStep[idx] = 2;
      setProductPackStepOption(productPackOptionStep);
    }
  };

  const returnImage = () => {
    if (productPackStepOption[idx] === 1) {
      return (
        <Image
          {...shapeProduct.variants[0].images[0]}
          width='100%'
          height='100%'
        />
      );
    } else {
      return (
        <Image
          {...variant.images[0]}
          width='100%'
          height='100%'
        />
      );
    }
  };

  return (
    <div className='p-4'>
      <div className='flex relative border w-full border-primary'>
        <button
          onClick={handleOnClick}
          type='button'
          className={`flex  transition duration-300 relative w-1/2 flex-col items-center justify-center ${
            isUniqueProduct ? 'cursor-auto' : ''
          } ${
            isWindowSmallSize
              ? ''
              : isUniqueProduct
              ? ''
              : 'opacity-50 hover:opacity-100'
          }`}>
          <div className='absolute top-0 h-2/3'>{returnImage()}</div>
          <div
            className={`${
              isButtonDisplayed
                ? 'bottom-5 sm:bottom-10'
                : 'bottom-10 sm:bottom-20'
            } inset-x-0 w-full absolute px-2`}>
            <Label
              {...shapeProduct.label}
              truncate
              size={`${isWindowSmallSize ? '2xl' : '4xl'}`}
            />
            {isButtonDisplayed && (
              <div className='pt-2 sm:pt-5'>
                <Button
                  {...button}
                  type='contained'
                  size='xs'
                  color={category?.color}
                />
              </div>
            )}
          </div>
        </button>
        <div className='pack-shapes-picker-image-slider w-1/2 border-l border-black'>
          <Slider
            hasAutoPlay
            hasDots
            centerMode
            pauseOnHover={false}
            autoplaySpeed={5000}
            centerPadding={0}
            slidesToShow={1}
            isInfinite
            initialSlide={checkParity}>
            {shapeProduct.lifestyleImages.map((image) => (
              <div className='w-full h-full'>
                <Image
                  {...image}
                  width='100%'
                  height='100%'
                  objectFit='cover'
                  bgColor='gray-200'
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export const ProductPackShapesPicker = ({
  products,
  idx,
  button,
  category,
}) => (
  <div className='flex flex-col overflow-scroll w-full no-scrollbar'>
    {products.map((product, index) => (
      <ShapePicker
        shapeProduct={product}
        idx={idx}
        button={button}
        shapeIndex={index}
        productsLength={products.length}
        category={category}
      />
    ))}
  </div>
);
